import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    details: string;
    move: string;
    title: string;
    metadataWarningTitle: string;
    metadataWarningDescription: string;
    moveAnyway: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.details?c=1yqurtrzeee1r", defaultMessage: "All folder members will lose access. Only you will retain access." }));
                },
                enumerable: true,
                configurable: true
            },
            move: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.move?c=27die772mtfh1", defaultMessage: "Move" }));
                },
                enumerable: true,
                configurable: true
            },
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.title?c=29rntz3xh2lx4", defaultMessage: "You''re about to move a restricted folder" }));
                },
                enumerable: true,
                configurable: true
            },
            metadataWarningTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.metadataWarningTitle?c=1h98rhsvl2208", defaultMessage: "Custom fields will be lost" }));
                },
                enumerable: true,
                configurable: true
            },
            metadataWarningDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.metadataWarningDescription?c=13kmvyfu0d7v2", defaultMessage: "Any custom fields or field values will be lost when assets are moved to a new project." }));
                },
                enumerable: true,
                configurable: true
            },
            moveAnyway: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useMoveAssets.moveAnyway?c=21lq0jgwalh07", defaultMessage: "Move Anyway" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
